js_check_local()
function js_check_local(){
    document.addEventListener('DOMContentLoaded', initCheckLocal)
}

// inicializar check local
function initCheckLocal() {
    const contents = document.querySelectorAll('.js-chcek-local')
    const items = document.querySelectorAll('.js-chcek-local__item')
    const titles = document.querySelectorAll('.js-chcek-local__title')
    const titlesLink = document.querySelectorAll('.js-chcek-local__title-link')
    
    if (contents != null) {
        init()
    }
    
    function init(){
        for (let i = 0; i < contents.length; i++) {
            checkLocal(contents[i])
        }
        innerTitleLink()
    }

    function checkLocal(content) {
        const check = content.dataset.check
        let data
    
        for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i) == check) {
                data = localStorage.getItem(check)
            }
        }

        viewItems(data)
        innerTitle(data)
    }

    function viewItems(data) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].dataset.typo == data) {
                items[i].classList.remove('d-none')
                items[i].classList.add('d-block')
            }
        }
    }

    function innerTitle(data) {
        for (let i = 0; i < titles.length; i++) {
            titles[i].innerHTML = data
        }
    }

    function innerTitleLink() {
        titlesLink.forEach(link => {
            for (let i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i) == link.dataset.link) {
                    data = localStorage.getItem(link.dataset.link)
                    link.innerHTML = data
                }
            }
        })
    }
}
